import React from 'react'
import PropTypes from 'prop-types'
import {
  withTranslation, TRANSLATION_VALUE_KEYS, TRANSLATION_KEYS
} from 'LiveBoard/hocs'

import './style.css.scss'

class Description extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isCollapsed: false,
      canCollapse: false
    }

    this.windowWidth = null
    this.resizeTimeout = null
  }

  componentDidMount() {
    setTimeout(this.setCanCollapse, 0) //this is a hack in order to arrive to setCanCollapse after styles are rendered
    window.addEventListener('resize', this.onResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize)
  }

  onResize = () => {
    this.resizeTimeout && clearTimeout(this.resizeTimeout)
    this.resizeTimeout = setTimeout(this.setCanCollapse, 200)
  }

  toggleCollapse = (event) => {
    event.stopPropagation()
    this.setState({ isCollapsed: !this.state.isCollapsed })
  }

  setCanCollapse = () => {
    if(this.windowWidth == window.innerWidth) {
      return
    }
    this.windowWidth = window.innerWidth
    const canCollapse = this.container.scrollHeight > this.container.offsetHeight
    this.setState({ canCollapse: canCollapse })
  }

  render() {
    return (
      <p
        ref={ref => this.container = ref}
        className={`item-description ${!this.state.isCollapsed ? 'closed' : 'opened'}`}>
        { this.props.text }
        { this.state.canCollapse && (
          <span onClick={this.toggleCollapse} style={{color: this.props.themeColorHex}}>
            {
              this.props.getTranslation(
                this.state.isCollapsed ?
                  TRANSLATION_VALUE_KEYS.less : TRANSLATION_VALUE_KEYS.more
              ).toLowerCase()
            }
          </span>
        )}
      </p>
    )
  }
}

Description.propTypes = {
  text: PropTypes.string.isRequired,
  themeColorHex: PropTypes.string.isRequired
}

export default withTranslation(TRANSLATION_KEYS.itemDescription)(Description)
